// Kredi Ödemeleri sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'finance.loanPayments';

export const loanPaymentsGuide = (t: TFunction): GuideContent => ({
  layout: 'list',
  title: t(`${G}.title`, 'Kredi Ödemeleri nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Tüm kredilerinizin ödenmiş taksitlerini tek listede görürsünüz. Taksit ödemesi buradan değil, Krediler sayfasındaki kredi detayından yapılır. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık'),
    filters: t(`${G}.regions.filters`, 'Arama, kredi ve tarih'),
    table: t(`${G}.regions.table`, 'Ödeme listesi'),
  },
  steps: [
    {
      region: 'filters',
      title: t(`${G}.s1.title`, '1. Ödemeleri süzün'),
      text: t(`${G}.s1.text`, 'Arama kutusuna kredi adı veya açıklama yazın. "Kredi" listesinden tek bir krediyi seçin, Başlangıç ve Bitiş tarihleriyle dönemi daraltın. "Yenile" listeyi yeniden yükler.'),
    },
    {
      region: 'table',
      title: t(`${G}.s2.title`, '2. Sütunları okuyun'),
      text: t(`${G}.s2.text`, 'Her satır bir taksit ödemesidir: ödeme tarihi, kredi, taksit no, taksit tutarı, varsa gecikme faizi ve Toplam Ödenen (taksit + gecikme faizi). Ödeyen sütunu işlemi yapan kullanıcıyı gösterir.'),
    },
    {
      region: 'table',
      title: t(`${G}.s3.title`, '3. Ödeme kaynağını kontrol edin'),
      text: t(`${G}.s3.text`, 'Kaynak sütunu paranın nereden çıktığını gösterir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Kasa: tutar seçilen kasadan düşülmüştür.'),
        t(`${G}.s3.tip2`, 'Banka: tutar seçilen banka hesabından düşülmüştür.'),
        t(`${G}.s3.tip3`, 'Tahakkuk (Elden): kasa veya banka bakiyesi değişmemiştir; taksit yalnız ödendi olarak işaretlenmiştir.'),
      ],
    },
    {
      region: 'table',
      title: t(`${G}.s4.title`, '4. Hatalı ödemeyi silin'),
      text: t(`${G}.s4.text`, 'Satırın sonundaki çöp kutusu ödemeyi kalıcı olarak siler; bu işlem geri alınamaz.'),
      tips: [
        t(`${G}.s4.tip1`, 'Ödeme kasadan veya bankadan yapıldıysa ilgili kasa / banka hareketi de silinir ve tutar bakiyeye geri eklenir.'),
        t(`${G}.s4.tip2`, 'Taksit tekrar "Bekliyor" durumuna döner; kredi kapanmışsa yeniden aktif olur.'),
      ],
    },
    {
      region: 'pagination',
      title: t(`${G}.s5.title`, '5. Sayfalar arasında gezin'),
      text: t(`${G}.s5.text`, 'Liste uzunsa alttaki sayfalama ile ilerleyin ve sayfa başına satır sayısını seçin. Başlıktaki (i) düğmesi bu rehberi yeniden açar.'),
    },
  ],
});
